if (!customElements.get('custom-print-on-demand')) {
  const FLOWGATE_EDIT_BASE_URL = 'https://notique.flowgate.eu/cs/kosik/edit.product/default/';

  class CustomPrintOnDemand extends HTMLElement {
    constructor() {
      super();
      console.log("-- Custom print on demand constructor --");
      
      this.flowgateDesignId = null;
      this.productUrl = null;
      this.currentState = 'loading';
    }

    connectedCallback() {
      // Get the flowgate_design_id from URL parameters
      this.flowgateDesignId = this.getUrlParameter('flowgate_design_id');
      
      // Get the product URL from data attribute
      this.productUrl = this.dataset.productUrl;
      
      // Initialize the component
      this.init();
    }

    getUrlParameter(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }

    init() {
      this.determineState();
      this.updateDynamicContent();
      this.showCurrentState();
      
      // Auto-scroll to component if design ID is present
      if (this.flowgateDesignId) {
        setTimeout(() => {
          this.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }, 100); // Small delay to ensure content is rendered
      }
    }

    determineState() {
      if (this.flowgateDesignId) {
        this.currentState = 'add-to-cart';
      } else {
        this.currentState = 'create';
      }
    }

    updateDynamicContent() {
      if (this.flowgateDesignId) {
        // Update design ID display
        const designIdValue = this.querySelector('.custom-pod__design-id-value');
        if (designIdValue) {
          designIdValue.textContent = this.flowgateDesignId;
        }

        // Update edit button link (with design ID)
        const editBtn = this.querySelector('.custom-pod__edit-btn');
        if (editBtn && this.productUrl) {
          editBtn.href = `${FLOWGATE_EDIT_BASE_URL}${this.flowgateDesignId}`;
        }

        // Update new design button: reset to variant picker when product has variations,
        // otherwise go to the product builder without a design ID
        const newBtn = this.querySelector('.custom-pod__new-btn');
        if (newBtn) {
          if (this.dataset.hasVariations === 'true') {
            newBtn.href = `${window.location.pathname}#custom-pod`;
          } else if (this.productUrl) {
            newBtn.href = this.productUrl;
          }
        }

        // Set the hidden input value for line item property
        const hiddenInputData = this.querySelector('#flowgate-design-id-input-data');
        const hiddenInputPresentation = this.querySelector('#flowgate-design-id-input-presentation');
        if (hiddenInputData) {
          hiddenInputData.value = this.flowgateDesignId;
        }
        if (hiddenInputPresentation) {
          hiddenInputPresentation.value = this.flowgateDesignId;
        }

        // Show the design info
        const designInfo = this.querySelector('.custom-pod__design-info');
        if (designInfo) {
          designInfo.style.display = 'block';
        }
      }
    }

    showCurrentState() {
      // Hide all states
      this.querySelectorAll('.custom-pod__state').forEach(state => {
        state.style.display = 'none';
      });

      // Show current state
      const currentStateElement = this.querySelector(`.custom-pod__${this.currentState}`);
      if (currentStateElement) {
        currentStateElement.style.display = 'block';
      }
    }
  }

  customElements.define('custom-print-on-demand', CustomPrintOnDemand);
}